module.exports = __webpack_public_path__ + "static/media/raf.85ba738d.png";